import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
/****************************************************************************** */
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)
/***************************************************************************** */
import "./icons"
//按钮权限控制
// import HasPerm from './utils/hasPermission'
// Vue.use(HasPerm)

Vue.config.productionTip = false
if (['production', 'staging'].includes(process.env.NODE_ENV)) {
  window.console.log = () => {}
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
